import { AddToPhotos, Star, Download, ContentCopy, ArrowDropDown } from '@mui/icons-material';
import { Col, Input, Progress, Row, Form, Switch } from 'antd';
import { Checkbox, Button, Menu, MenuItem } from '@mui/material';
import { storage } from 'firebaseConfig';
import { ref as fireRef, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FileUploader } from "react-drag-drop-files";
import styled from 'styled-components';
import COLOR from "utils/constants/color";
import { v4 } from 'uuid';
import * as Sentry from '@sentry/react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';
import Tag from 'components/Tag';
import Hls from 'hls.js';
import { getCloudflareUploadUrl } from 'store/1wayteachervideo/thunks';
import { downloadVideoLikePreview } from 'utils/methods/cloudflareVideoDownload';
import { handleCloudflareVideoStatus } from 'store/interactions/thunks';
import { useCurrentUser } from 'store/users/selectors';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
const fileTypes = ["MP4","MOV"];


const ImageContainer = styled.div`
    height: auto;
    flex: 1;
    // height:70vh;
`;

const Images = styled.img`
    background-color: ${COLOR.white};
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
`;
const Container = styled.div`
    width: 100%;
    height: 100%;
    display:flex;
    align-item:center;
    justify-content:center;
    position: relative;
    background-color:${p => p.empty ? "rgba(0,0,0,0.1)" : "transparent"}
`;

const Page = styled.div`
    align-items: center;
    color: ${COLOR.black100};
    display: flex;
    flex-direction: row;
    font-size: 14px;
    font-weight: 400;
    white-space: nowrap;
`;

// const Input = styled.input`
//     background-color: transparent;
//     border: 1px dashed gray;
//     border-radius: 3px;
//     box-shadow: none;
//     font-size: inherit;
//     font-weight: 400;
//     outline: none;
//     padding: 0px 2px;
//     transition: all 300ms ease;
//     width:250px;
// `;
const FileUploadArea = styled.div`
    height: 100%;
    border: 1px dashed gray;
    padding: 5px 12px;
    min-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const Text = styled.div`
    font-size: 12px;
`;
const Column = styled(Col)`
display: flex;
    justify-content: center;
    align-items: center;
}
`;
const VideoContainer = styled.div`
  width: 100%;
  margin-bottom: 0px;
  border-bottom-width: ${(p) => (p.bottomWidth ? p.bottomWidth : "10px")};
  background-color:black;
  border-radius:8px;
  position: relative;

  @keyframes fadeInOut {
    0% { opacity: 0; transform: translateY(-10px); }
    10% { opacity: 1; transform: translateY(0); }
    90% { opacity: 1; transform: translateY(0); }
    100% { opacity: 0; transform: translateY(-10px); }
  }
`;

const VideoAdminActionsBar = styled.div`
  position: absolute;
  top: -9px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  z-index: 10;
  max-width: 100%;

  @media (max-width: 560px) {
    top: 5px;
    right: 5px;
    gap: 6px;
    flex-wrap: wrap;
  }
`;

const ACTION_TEAL = '#03989e';

const videoAdminActionButtonAttrs = {
  disableRipple: true,
  disableFocusRipple: true,
  color: 'primary',
};

const VideoAdminActionButton = styled(Button).attrs(videoAdminActionButtonAttrs)`
  position: static;
  flex-shrink: 0;
  background-color: rgba(0, 0, 0, 0.7) !important;
  color: ${ACTION_TEAL} !important;
  border: 1px solid ${ACTION_TEAL} !important;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 12px;
  white-space: nowrap;
  transition: none !important;
  box-shadow: none !important;

  &:hover {
    background-color: rgba(0, 0, 0, 0.8) !important;
    border-color: ${ACTION_TEAL} !important;
    color: ${ACTION_TEAL} !important;
  }

  &:focus,
  &:focus-visible,
  &.Mui-focusVisible {
    outline: none !important;
    box-shadow: none !important;
    background-color: rgba(0, 0, 0, 0.7) !important;
    border-color: ${ACTION_TEAL} !important;
    color: ${ACTION_TEAL} !important;
  }

  &:active {
    background-color: rgba(0, 0, 0, 0.8) !important;
    border-color: ${ACTION_TEAL} !important;
    color: ${ACTION_TEAL} !important;
  }

  .MuiButton-startIcon,
  .MuiButton-endIcon,
  .MuiSvgIcon-root {
    color: ${ACTION_TEAL} !important;
  }

  .MuiTouchRipple-root {
    display: none;
  }

  @media (max-width: 560px) {
    padding: 4px 8px;
    font-size: 11px;
  }
`;

const DownloadVideoButton = styled(VideoAdminActionButton)`
  min-width: 125px;
  justify-content: flex-start;

  ${(p) =>
    p.$downloading &&
    `
    cursor: wait;
    pointer-events: none;
    opacity: 1 !important;
    background-color: rgba(0, 0, 0, 0.7) !important;
    color: ${ACTION_TEAL} !important;
    border-color: ${ACTION_TEAL} !important;

    .MuiButton-startIcon,
    .MuiSvgIcon-root {
      color: ${ACTION_TEAL} !important;
    }
  `}
`;
const DatePickerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  margin-top: 20px;

  .MuiTextField-root {
    width: 48%;
  }
`;
const WeekDaysContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
const DayItem = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10%;
  font-weight: ${(props) => (props.isInRange ? '600' : '400')};
  color: ${(props) => (props.isInRange ? '#000' : '#ccc')};
  background-color: ${(props) => (props.isSelected ? '#4096ff' : 'transparent')};
  color: ${(props) => (props.isSelected ? '#fff' : props.isInRange ? '#000' : '#000000e0')};
  cursor: ${(props) => (props.isInRange ? 'pointer' : 'default')};
  transition: all 0.3s ease;
  font-size: 14px;

  &:hover {
    background-color: ${(props) =>
      props.isInRange && !props.isSelected
        ? '#e6f7ff'
        : props.isSelected
          ? '#4096ff'
          : 'transparent'};
  }

  ${(props) =>
    !props.isInRange &&
    `
        pointer-events: none;
        opacity: 0.4;
    `}
`;
const Note = styled.span`
  color: ${COLOR.black400};
  display: block;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
`;
const Video = styled.video`
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  height: auto;
  outline: none;
  max-height:400px;
  width: 100%;
`;
export default function VideoPicker({ 
    src, 
    poster, 
    onChange, 
    description, 
    onChangeDescription, 
    style, 
    hasDescription, 
    pageId, 
    path, 
    setButtonDisabled = () => {},
    startDate,
    endDate,
    isWelcomeVideo = false,
    initialSelectedDays = [],
    onDateChange = () => {},
    isActive = false,
    onToggleActive = () => {},
    onToggleInActive = () => {},
    initialRoleFilters = { teacher: true, student: false },
    onRoleFilterChange = () => {},
    onDaySelect = () => {},
    to_cloudflare = false,
    onStreamReadyChange,
}) {
    const [source, setSource] = useState(src)
    const [loader, setLoader] = useState(false)
    const [loadingMap, setLoadingMap] = useState(0)
    const videoRef = useRef()
    const [videoStartDate, setVideoStartDate] = useState(startDate);
    const [videoEndDate, setVideoEndDate] = useState(endDate);
    const [daysInRange, setDaysInRange] = useState([]);
    const [selectedDays, setSelectedDays] = useState(initialSelectedDays);
    const [switchActive, setSwitchActive] = useState(isActive);
    const [selectedTypes, setSelectedTypes] = useState(initialRoleFilters);
    const [uploadSpeed, setUploadSpeed] = useState(0);
    const lastProgressRef = useRef({ bytes: 0, time: Date.now() });
    const currentUser = useCurrentUser();
    const [downloading, setDownloading] = useState(false);
    const [downloadStatus, setDownloadStatus] = useState(null);
    const showAlert = useAlert();
    const [menuAnchor, setMenuAnchor] = useState(null);
    const [urlInput, setUrlInput] = useState('');
    const [showUrlInput, setShowUrlInput] = useState(false);
    const [isAddVideoMode, setIsAddVideoMode] = useState(false);
    const urlSubmitTimeoutRef = useRef(null);
    const streamReadyCbRef = useRef(onStreamReadyChange);
    streamReadyCbRef.current = onStreamReadyChange;

    const dataUrl = useMemo(() => source, [source]);
    const isHls = useMemo(() => typeof dataUrl === 'string' && dataUrl.includes('.m3u8'), [dataUrl]);
    const dispatch = useDispatch();
    const [videoProcessing, setVideoProcessing] = useState(isHls);
    const [videoReady, setVideoReady] = useState(false);
    const [showReadyBadge, setShowReadyBadge] = useState(false);
    const hlsPoster = useMemo(() => {
        if(poster) return poster;
        if(isHls){
            const videoId = dataUrl.split('/')[3];
            if(videoId){
                return `https://customer-quvpuvq5vklyms5a.cloudflarestream.com/${videoId}/thumbnails/thumbnail.jpg`;
            }
        }
        return null;
    }, [poster, dataUrl, isHls]);
    
    const weekDays = [
        { key: 'monday', label: 'M', fullName: 'Monday' },
        { key: 'tuesday', label: 'T', fullName: 'Tuesday' },
        { key: 'wednesday', label: 'W', fullName: 'Wednesday' },
        { key: 'thursday', label: 'T', fullName: 'Thursday' },
        { key: 'friday', label: 'F', fullName: 'Friday' },
        { key: 'saturday', label: 'S', fullName: 'Saturday' },
        { key: 'sunday', label: 'S', fullName: 'Sunday' }
    ];
    
    useEffect(() => {
        if (src !== source) {
            setSource(src);
        if (src && src.includes('.m3u8')) {
            setVideoProcessing(true);
            setVideoReady(false);
        } else {
            setVideoProcessing(false);
            setVideoReady(true);
        }
        }
    }, [src, source])

    useEffect(() => {
        setVideoStartDate(startDate)
        setVideoEndDate(endDate)
    }, [startDate, endDate])

    useEffect(() => {
        if (initialSelectedDays && initialSelectedDays.length > 0) {
          setSelectedDays(initialSelectedDays)
        }
    }, [])

    useEffect(() => {
      setSwitchActive(isActive)
    }, [isActive])
  
    useEffect(() => {
      setSelectedTypes(initialRoleFilters);
    }, []);

    useEffect(() => {
        if (videoReady) {
            setShowReadyBadge(true);
            const timer = setTimeout(() => {
                setShowReadyBadge(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [videoReady]);

    useEffect(() => {
        const video = videoRef.current;
        if (!video || !isHls) return;

        let hls;
        let retryTimeout;
        let retryCount = 0;
        const maxRetries = 10;

        const attemptLoad = () => {
            if (retryCount >= maxRetries) {
                console.log('Max retries reached, video may not be available');
                setVideoProcessing(true);
                setVideoReady(false);
                return;
            }

            setVideoProcessing(true);
            setVideoReady(false);

            if (Hls.isSupported()) {
                if (hls) {
                    hls.destroy();
                }
                
                hls = new Hls({ 
                    lowLatencyMode: true,
                    enableWorker: true,
                    backBufferLength: 90
                });
                
                hls.loadSource(dataUrl);
                hls.attachMedia(video);
                
                try {
                  hls.on(Hls.Events.ERROR, (event, data) => {
                    console.log('HLS.js error:', data);
                    
                    if (data.fatal) {
                        switch (data.type) {
                            case Hls.ErrorTypes.NETWORK_ERROR:
                                console.log('Network error - video may still be processing, retry:', retryCount + 1);
                                setVideoProcessing(true);
                                setVideoReady(false);
                                
                                retryCount++;
                                retryTimeout = setTimeout(() => {
                                    console.log('Retrying HLS load...');
                                    attemptLoad();
                                }, 5000);
                                break;
                            case Hls.ErrorTypes.MEDIA_ERROR:
                                console.log('Media error - video may still be processing');
                                setVideoProcessing(true);
                                setVideoReady(false);
                                hls.recoverMediaError();
                                break;
                            default:
                                console.log('Fatal error - video may not be ready yet');
                                setVideoProcessing(true);
                                setVideoReady(false);
                                retryCount++;
                                retryTimeout = setTimeout(() => {
                                    attemptLoad();
                                }, 5000);
                                break;
                        }
                    }
                });

                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                    console.log('HLS manifest parsed - video is ready');
                    setVideoProcessing(false);
                    setVideoReady(true);
                    retryCount = 0;
                    if (retryTimeout) {
                        clearTimeout(retryTimeout);
                    }
                });

                hls.on(Hls.Events.LEVEL_LOADED, () => {
                    console.log('HLS level loaded - video is ready');
                    setVideoProcessing(false);
                    setVideoReady(true);
                    retryCount = 0;
                });
                } catch (error) {
                  console.log('HLS error:', error);
                  setVideoProcessing(true);
                  setVideoReady(false);
                }
            } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
                video.src = dataUrl;
                video.addEventListener('loadedmetadata', () => {
                    setVideoProcessing(false);
                    setVideoReady(true);
                    retryCount = 0;
                });
                video.addEventListener('error', () => {
                    setVideoProcessing(true);
                    setVideoReady(false);
                    retryCount++;
                    if (retryCount < maxRetries) {
                        retryTimeout = setTimeout(() => {
                            attemptLoad();
                        }, 5000);
                    }
                });
            }
        };

        attemptLoad();

        return () => {
            if (hls) {
                hls.destroy();
            }
            if (retryTimeout) {
                clearTimeout(retryTimeout);
            }
        };
    }, [dataUrl, isHls]);

    useEffect(() => {
        if (!streamReadyCbRef.current) return;
        const hasUrl = Boolean(source && String(source).trim());
        const uploading = Boolean(loader);
        const hlsWaiting = isHls && (videoProcessing || !videoReady);
        const streamReady = hasUrl && !uploading && !hlsWaiting;
        streamReadyCbRef.current(streamReady);
    }, [source, loader, isHls, videoProcessing, videoReady]);

    useEffect(() => {
        if (videoStartDate && videoEndDate) {
            const start = dayjs(videoStartDate);
            const end = dayjs(videoEndDate);
            const daysInDateRange = [];
            
            let current = start;
            while (current.isSame(end) || current.isBefore(end)) {
                const dayName = current.format('dddd').toLowerCase();
                if (!daysInDateRange.includes(dayName)) {
                    daysInDateRange.push(dayName);
                }
                current = current.add(1, 'day');
            }
            
            setDaysInRange(daysInDateRange);
            if (initialSelectedDays && initialSelectedDays.length > 0) {
                setSelectedDays(initialSelectedDays);
            }
        } else {
            setDaysInRange([]);
            setSelectedDays([]);
        }
    }, [videoStartDate, videoEndDate]);

    const handleDateChange = (type, newValue) => {
        const formattedDate = newValue ? dayjs(newValue).format('YYYY-MM-DD') : null;
        
        if (type === 'start') {
            setVideoStartDate(formattedDate);
            if (videoEndDate && dayjs(videoEndDate).isBefore(newValue)) {
                setVideoEndDate(null);
                onDateChange('end', null);
            }
            onDateChange('start', formattedDate);
            if (!formattedDate) {
                setSelectedDays([]);
                onDaySelect([]);
            }
        } else if (type === 'end') {
            setVideoEndDate(formattedDate);
            onDateChange('end', formattedDate);
            if (!formattedDate) {
                setSelectedDays([]);
                onDaySelect([]);
            }
        }
    };

    const handleDayClick = (dayKey) => {
        if (!daysInRange.includes(dayKey)) return;
        
        let newSelectedDays;
        if (selectedDays.includes(dayKey)) {
            newSelectedDays = selectedDays.filter(day => day !== dayKey);
        } else {
            newSelectedDays = [...selectedDays, dayKey];
        }
        
        setSelectedDays(newSelectedDays);
        onDaySelect(newSelectedDays);
    };
    const handleToggleActive = (state) => {
        if (state && isWelcomeVideo && (!selectedTypes.teacher && !selectedTypes.student)) {
            setSwitchActive(false);
            onToggleInActive(false);
            return;
        }
        
        setSwitchActive(state);
        if (state) {
          onToggleActive(state);
        } else {
            onToggleInActive(state);
        }
    };
  
    const handleChangeCheckbox = (type) => (event) => {
      const newValue = event.target.checked;
      const updatedTypes = {
        ...selectedTypes,
        [type]: newValue,
      };

      const noneSelected = !updatedTypes.teacher && !updatedTypes.student;
      if (switchActive && noneSelected) {
        return;
      }
      setSelectedTypes(updatedTypes);
      onRoleFilterChange(updatedTypes);
    };

    const extractCloudflareVideoId = (url) => {
        try {
            if (url && typeof url === 'string') {
                if (url.includes('cloudflarestream.com')) {
                    const match = url.match(/cloudflarestream\.com\/([a-zA-Z0-9]+)/);
                    return match ? match[1] : null;
                }
                if (url.includes('.m3u8')) {
                    const match = url.match(/\/([a-zA-Z0-9]+)\/manifest\/video\.m3u8/);
                    return match ? match[1] : null;
                }
            }
            return null;
        } catch (error) {
            console.error('Error extracting Cloudflare video ID:', error);
            return null;
        }
    };

    const isCloudflareUrl = (url) => {
        return url && typeof url === 'string' && (url.includes('cloudflarestream.com') || url.includes('.m3u8'));
    };

    const isValidVideoUrl = (url) => {
        try {
            if (!url || typeof url !== 'string') {
                return false;
            }

            const trimmedUrl = url.trim();
            if (!trimmedUrl) {
                return false;
            }

            const lowerUrl = trimmedUrl.toLowerCase();
            let urlToCheck = trimmedUrl;
            if (!trimmedUrl.startsWith('http://') && !trimmedUrl.startsWith('https://')) {
                urlToCheck = 'https://' + trimmedUrl;
            }
            
            try {
                new URL(urlToCheck);
            } catch (e) {
                return false;
            }
            if (lowerUrl.includes('cloudflarestream.com') || lowerUrl.includes('.m3u8')) {
                return true;
            }
            let decodedUrl = lowerUrl;
            try {
                decodedUrl = decodeURIComponent(lowerUrl).toLowerCase();
            } catch (e) {
                decodedUrl = lowerUrl;
            }
            const videoExtensions = ['.mp4', '.mov', '.webm', '.avi', '.mkv', '.flv', '.wmv', '.m4v', '.3gp', '.ogv'];
            if (videoExtensions.some(ext => lowerUrl.includes(ext) || decodedUrl.includes(ext))) {
                return true;
            }
            if (lowerUrl.includes('youtube.com') || lowerUrl.includes('youtu.be') || lowerUrl.includes('youtube-nocookie.com')) {
                return true;
            }
            if (lowerUrl.includes('vimeo.com')) {
                return true;
            }

            return false;
        } catch (error) {
            console.error('Error validating video URL:', error);
            return false;
        }
    };

    const handleMenuOpen = (event) => {
        setMenuAnchor(event.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuAnchor(null);
    };

    const handleCopyUrl = async () => {
        if (!source) return;
        
        try {
            await navigator.clipboard.writeText(source);
            showAlert('Video URL copied to clipboard!', 'success');
            setIsAddVideoMode(false);
            handleMenuClose();
        } catch (error) {
            console.error('Error copying URL:', error);
            showAlert('Failed to copy URL. Please try again.', 'error');
            setIsAddVideoMode(false);
            handleMenuClose();
        }
    };

    const handleAddVideoWithUrl = () => {
        handleMenuClose();
        setShowUrlInput(true);
        setUrlInput('');
        setIsAddVideoMode(true);
    };

    const handleUrlSubmit = () => {
        try {
            const trimmedUrl = urlInput.trim();
            if (!trimmedUrl) {
                if (showAlert && typeof showAlert === 'function') {
                    showAlert('Please enter a valid URL', 'error');
                }
                return;
            }
            if (!isValidVideoUrl(trimmedUrl)) {
                if (showAlert && typeof showAlert === 'function') {
                    showAlert('Invalid URL. Please enter a valid video URL.', 'error');
                }
                return;
            }
            setShowUrlInput(false);
            setUrlInput('');
            setIsAddVideoMode(false);
            if (urlSubmitTimeoutRef.current) {
                clearTimeout(urlSubmitTimeoutRef.current);
                urlSubmitTimeoutRef.current = null;
            }
            if (onChange && typeof onChange === 'function') {
                try {
                    onChange({ url: trimmedUrl, pageId: pageId || undefined });
                } catch (error) {
                    console.error('Error in onChange callback:', error);
                }
            }
            setSource(trimmedUrl);
            
            if (showAlert && typeof showAlert === 'function') {
                showAlert('Video URL added successfully!', 'success');
            }
        } catch (error) {
            console.error('Error submitting video URL:', error);
            if (showAlert && typeof showAlert === 'function') {
                showAlert('Failed to add video URL. Please try again.', 'error');
            }
            setSource(src);
        }
    };

    const handleUrlInputKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleUrlSubmit();
        }
    };

    const handleUrlChange = (e) => {
        const value = e.target.value;
        setUrlInput(value);
        if (urlSubmitTimeoutRef.current) {
            clearTimeout(urlSubmitTimeoutRef.current);
            urlSubmitTimeoutRef.current = null;
        }
    };

    const handleDownload = async (event) => {
        if (!source || downloading) return;

        event.currentTarget.blur();
        setDownloading(true);
        setDownloadStatus('preparing');

        try {
            const videoId = isCloudflareUrl(source) ? extractCloudflareVideoId(source) : null;
            const fileName = videoId ? `video-${videoId}.mp4` : 'video.mp4';

            await downloadVideoLikePreview({
                url: source,
                fileName,
                showAlert,
                onProgress: (status) => setDownloadStatus(status),
            });
        } catch (error) {
            console.error('Error downloading video:', error);
            setDownloadStatus('error');
            showAlert(error.message || 'Failed to prepare download. Please try again.', 'error');
        } finally {
            setTimeout(() => {
                setDownloading(false);
                setDownloadStatus(null);
            }, 1000);
        }
    };

    const handleChange = (file) => {
        if (to_cloudflare) {
            uploadToCloudflare(file, pageId);
        } else {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = function (e) {
                let v = reader.result;
                setSource(v)
            };
            uploadToStorage(file, pageId);
        }
    };

    useEffect(() => {
        if (videoRef.current && source) {
            const video = videoRef.current;
            video.pause();
            video.currentTime = 0;
            video.load();
        }
    }, [source])

    const uploadToCloudflare = async (file, index) => {
        if (!file) {
            console.log("No file to upload.");
            return;
        }

        if (setButtonDisabled) {
            setButtonDisabled(true);
        }

        const fileSizeInMB = file.size / (1024 * 1024);
        const useTusProtocol = true;

        try {
            setLoader(true);
            setLoadingMap(0);
            
            console.log(`Uploading video: ${file.name} (${fileSizeInMB.toFixed(2)} MB) using TUS protocol`);

            const uploadUrlData = await getCloudflareUploadUrl(21600, useTusProtocol, file.name, file.size);
            if (!uploadUrlData || !uploadUrlData.uploadURL || !uploadUrlData.uid) {
                throw new Error('Failed to get Cloudflare upload URL');
            }

            const { uploadURL, uid } = uploadUrlData;

            dispatch(handleCloudflareVideoStatus({
                id: uid,
                created_at: new Date().toISOString(),
                is_video_generated: false,
                status: "processing",
                playback_url: `https://customer-quvpuvq5vklyms5a.cloudflarestream.com/${uid}/manifest/video.m3u8`,
                file_name: file?.name,
            }));

            if (useTusProtocol) {
                const tusModule = await import('tus-js-client');
                const Upload = tusModule.Upload;
                console.log('Starting TUS upload for file:', file.name, 'Size:', file.size, 'bytes');
                console.log('Upload URL:', uploadURL);
                
                const optimalChunkSize = fileSizeInMB < 500 
                    ? 5 * 1024 * 1024
                    : fileSizeInMB < 1000 
                        ? 10 * 1024 * 1024 
                        : 20 * 1024 * 1024;
                
                const upload = new Upload(file, {
                    endpoint: uploadURL,
                    retryDelays: [0, 1000, 3000, 5000],
                    chunkSize: optimalChunkSize,
                    removeFingerprintOnSuccess: true,
                    parallelUploads: 1,
                    storeFingerprintForResuming: true,
                    metadata: {
                        filename: file.name,
                        filetype: file.type
                    },
                    uploadSize: file.size,
                    onError: (error) => {
                        console.error("TUS upload failed:", error);
                        Sentry.captureException(`TUS upload error: ${error}`);
                        setLoader(false);
                        setLoadingMap(0);
                        setUploadSpeed(0);
                        if (setButtonDisabled) {
                            setButtonDisabled(false);
                        }
                    },
                    onProgress: (bytesUploaded, bytesTotal) => {
                        const percentage = Math.floor((bytesUploaded / bytesTotal) * 100);
                        setLoadingMap(percentage);
                        
                        const now = Date.now();
                        const timeDiff = (now - lastProgressRef.current.time) / 1000;
                        const bytesDiff = bytesUploaded - lastProgressRef.current.bytes;
                        
                        if (timeDiff > 0.5) {
                            const speedMBps = (bytesDiff / timeDiff / (1024 * 1024)).toFixed(2);
                            setUploadSpeed(speedMBps);
                            lastProgressRef.current = { bytes: bytesUploaded, time: now };
                            
                            const uploadedMB = (bytesUploaded / (1024 * 1024)).toFixed(2);
                            const totalMB = (bytesTotal / (1024 * 1024)).toFixed(2);
                            console.log(`Upload progress: ${percentage}% (${uploadedMB}/${totalMB} MB) - Speed: ${speedMBps} MB/s`);
                        }
                    },
                    onSuccess: async () => {
                        console.log("TUS upload completed successfully");
                        const hlsUrl = `https://customer-quvpuvq5vklyms5a.cloudflarestream.com/${uid}/manifest/video.m3u8`;
                        setSource(hlsUrl);
                        onChange({ url: hlsUrl, pageId: index });
                        dispatch(handleCloudflareVideoStatus({
                            id: uid,
                            created_at: new Date().toISOString(),
                            is_video_generated: false,
                            status: "done",
                            playback_url: hlsUrl,
                            file_name: file?.name,
                        }));
                        setVideoProcessing(true);
                        setVideoReady(false);
                        setLoader(false);
                        setLoadingMap(0);
                        setUploadSpeed(0);
                        if (setButtonDisabled) {
                            setButtonDisabled(false);
                        }
                    }
                });

                lastProgressRef.current = { bytes: 0, time: Date.now() };
                upload.start();
            } else {
                const formData = new FormData();
                formData.append('file', file);

                const response = await fetch(uploadURL, {
                    method: 'POST',
                    body: formData,
                });

                if (response.ok) {
                    const hlsUrl = `https://customer-quvpuvq5vklyms5a.cloudflarestream.com/${uid}/manifest/video.m3u8`;
                    setSource(hlsUrl);
                    onChange({ url: hlsUrl, pageId: index });
                    dispatch(handleCloudflareVideoStatus({
                        id: uid,
                        created_at: new Date().toISOString(),
                        is_video_generated: false,
                        status: "done",
                        playback_url: hlsUrl,
                        file_name: file?.name,
                    }));
                    setVideoProcessing(true);
                    setVideoReady(false);
                    setLoader(false);
                    setLoadingMap(0);
                    if (setButtonDisabled) {
                        setButtonDisabled(false);
                    }
                } else {
                    throw new Error(`Upload failed: HTTP ${response.status}`);
                }
            }
        } catch (error) {
            Sentry.captureException(`Cloudflare upload error: ${error}`);
            console.error('Cloudflare upload failed:', error);
            setLoader(false);
            setLoadingMap(0);
            setUploadSpeed(0);
            if (setButtonDisabled) {
                setButtonDisabled(false);
            }
        }
    };

    const uploadToStorage = async (file, index) => {
        if (file) {
          const location = path || '/videos';
          const id = `${moment().format('YYYY-MM-DD')}-${v4()}${file.name}`;
          const fileRef = fireRef(storage, `${location}/${id}`);
          if(setButtonDisabled){
            setButtonDisabled(true);
            } 
          try {
            const uploadTask = uploadBytesResumable(fileRef, file);
      
            uploadTask.on('state_changed',
              (snapshot) => {
                const per = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                setLoadingMap(per);
                setLoader(true);
                if(setButtonDisabled){
                    setButtonDisabled(true);
                }
              }, 
              (error) => {
                console.error("Upload error:", error);
                setLoader(false);
                setLoadingMap(0);
              }, 
              () => {
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                  setLoader(false);
                  setLoadingMap(0);
                  if(setButtonDisabled){
                    setButtonDisabled(false);
                    } 
                  setSource(downloadURL); 
                  onChange({ url: downloadURL, pageId: index });
                });
              }
            );
          } catch (error) {
            Sentry.captureException(`294 Error getting download URL: ${error}`);
            console.error("Upload error", error);
            setLoader(false);
            setLoadingMap(0);
          }
          finally{
            if(setButtonDisabled){
                setButtonDisabled(false);
            } 
        }
        } else {
          console.log("No file to upload.");
        }
      };
    return (
        <ImageContainer onContextMenu={(e) => { }} style={style}>
            {hasDescription ? <Row>
                <Col span={24} style={{ display: "flex", flexDirection: "row", marginBottom: 20 }} >
                    {/* <Page>
                        desctiption :&nbsp; <Input type="text" value={description || ''} onChange={e => onChangeDescription(e.target.value)} />
                    </Page> */}
                    <Input  addonBefore="Description" defaultValue="mysite" type="text" value={description || ''} onChange={e => onChangeDescription(e.target.value)} />
                </Col>
                <Col span={24} style={{ marginBottom: 10 }}>
                    <Form style={{ height: 30 }}>
                        <Form.Item label="Deactivate / Activate" valuePropName="checked">
                            <Switch checked={switchActive} onChange={handleToggleActive} />
                        </Form.Item>
                    </Form>
                </Col>
            </Row> : null}
            <Container>
                <VideoContainer>
                    <Video
                        controls
                        ref={videoRef}
                        poster={hlsPoster}
                        controlsList="nodownload"
                        width="100%"
                        preload="metadata"
                        key={source || 'video-placeholder'}
                    >
                        {!isHls && source && <source src={source} type="video/mp4" key={source} />}
                    </Video>
                    {videoProcessing && (
                        <div style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            background: 'rgba(0, 0, 0, 0.8)',
                            color: 'white',
                            padding: '20px',
                            borderRadius: '8px',
                            textAlign: 'center',
                            zIndex: 10
                        }}>
                            <div style={{ marginBottom: '10px' }}>
                                <Progress type="circle" percent={50} size="small" />
                            </div>
                            <div>Video is processing...</div>
                            <div style={{ fontSize: '12px', marginTop: '5px', opacity: 0.8 }}>
                                This may take a few minutes for large videos
                            </div>
                        </div>
                    )}
                    {showReadyBadge && isHls && (
                        <div style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                            background: 'rgba(76, 175, 80, 0.9)',
                            color: 'white',
                            padding: '8px 16px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            fontWeight: '500',
                            zIndex: 5,
                            animation: 'fadeInOut 3s ease-in-out',
                            pointerEvents: 'none'
                        }}>
                            ✓ Video Ready
                        </div>
                    )}
                    {currentUser && currentUser.role === "owe_admin" && (
                        <>
                            <VideoAdminActionsBar>
                            {source ? (
                                <>
                                    <VideoAdminActionButton
                                        variant="outlined"
                                        size="small"
                                        startIcon={isAddVideoMode ? <AddToPhotos /> : <ContentCopy />}
                                        endIcon={<ArrowDropDown />}
                                        onClick={handleMenuOpen}
                                    >
                                        {isAddVideoMode ? 'Add video with URL' : 'Copy URL'}
                                    </VideoAdminActionButton>
                                    <Menu
                                        anchorEl={menuAnchor}
                                        open={Boolean(menuAnchor)}
                                        onClose={handleMenuClose}
                                    >
                                        <MenuItem onClick={handleCopyUrl}>
                                            <ContentCopy style={{ marginRight: 8, fontSize: 18 }} />
                                            Copy URL
                                        </MenuItem>
                                        <MenuItem onClick={handleAddVideoWithUrl}>
                                            <AddToPhotos style={{ marginRight: 8, fontSize: 18 }} />
                                            Add video with URL
                                        </MenuItem>
                                    </Menu>
                        <DownloadVideoButton
                            variant="outlined"
                            size="small"
                            startIcon={<Download />}
                            onClick={handleDownload}
                            onMouseDown={(e) => e.preventDefault()}
                            $downloading={downloading}
                            aria-disabled={downloading}
                        >
                            {downloading 
                                ? (downloadStatus === 'preparing' 
                                    ? 'Preparing...' 
                                    : downloadStatus === 'processing' 
                                      ? 'Processing...' 
                                      : downloadStatus === 'ready'
                                        ? 'Downloading...'
                                        : 'Downloading...')
                                : 'Download'}
                        </DownloadVideoButton>
                                </>
                            ) : (
                                <VideoAdminActionButton
                                    variant="outlined"
                                    size="small"
                                    startIcon={<AddToPhotos />}
                                    onClick={handleAddVideoWithUrl}
                                >
                                    Add video URL
                                </VideoAdminActionButton>
                            )}
                            </VideoAdminActionsBar>
                            {showUrlInput && (
                                <div style={{
                                    position: 'absolute',
                                    top: '40px',
                                    right: '100px',
                                    background: 'rgba(0, 0, 0, 0.9)',
                                    padding: '12px',
                                    borderRadius: '8px',
                                    zIndex: 1000,
                                    minWidth: '300px',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
                                }}>
                                    <Input
                                        placeholder="Paste video URL here"
                                        value={urlInput}
                                        onChange={handleUrlChange}
                                        onPressEnter={handleUrlInputKeyPress}
                                        style={{ marginBottom: '8px' }}
                                        autoFocus
                                    />
                                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                                        <Button
                                            size="small"
                                            onClick={() => {
                                                setShowUrlInput(false);
                                                setUrlInput('');
                                                setIsAddVideoMode(false);
                                                if (urlSubmitTimeoutRef.current) {
                                                    clearTimeout(urlSubmitTimeoutRef.current);
                                                    urlSubmitTimeoutRef.current = null;
                                                }
                                            }}
                                            style={{ color: 'white' }}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            size="small"
                                            onClick={handleUrlSubmit}
                                            style={{
                                                color: 'white',
                                                borderColor: '#1890ff'
                                            }}
                                        >
                                            OK
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </VideoContainer>
                <FileUploader
                    classes={"file-uploader-cover center-video-uploader"}
                    handleChange={handleChange}
                    name="file"
                    types={fileTypes}

                >
                    <FileUploadArea>
                        {loader && (
                            <>
                                <Progress type="line" percent={loadingMap} size={"small"} className={"fileProgress"} showInfo={false} />
                                {uploadSpeed > 0 && (
                                    <Text style={{ marginTop: '5px', color: '#1890ff', fontSize: '11px', textAlign: 'center' }}>
                                        Uploading at {uploadSpeed} MB/s • {loadingMap}% complete
                                    </Text>
                                )}
                            </>
                        )}
                        <Row className="box box-1 dropZoneUploader" style={{display:"flex",justifyContent:"space-between"}}>
                            <Column>
                                <AddToPhotos color="primary" />
                            </Column>
                            <Column >
                                <Text>
                                    Upload or drop a file right here
                                </Text>
                            </Column>
                            <Column>
                                <Text>
                                    {fileTypes.join(",")}
                                </Text>
                            </Column>
                        </Row>

                    </FileUploadArea>
                </FileUploader>
            </Container>
      {isWelcomeVideo && (
        <>
          <Row>
            <Col span={24} style={{ marginBottom: 20 }}>
              <DatePickerContainer>
                <DatePicker
                  label="Start Date"
                  format="MM-DD-YYYY"
                  value={videoStartDate ? dayjs(videoStartDate) : null}
                  minDate={dayjs()}
                  onChange={(newValue) => handleDateChange('start', newValue)}
                  slotProps={{
                    textField: {
                      variant: 'outlined',
                      placeholder: 'Start date',
                      className: 'videoPickerDate',
                      InputLabelProps: {
                        shrink: true,
                      },
                      InputProps: {
                        endAdornment: videoStartDate && (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div
                              style={{ cursor: 'pointer', display: 'flex' }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDateChange('start', null);
                              }}
                            >
                              <CloseIcon fontSize="small" />
                            </div>
                            <div
                              className="MuiInputAdornment-root MuiInputAdornment-positionEnd MuiInputAdornment-outlined MuiInputAdornment-sizeMedium css-elo8k2-MuiInputAdornment-root"
                              style={{ marginLeft: '0px' }}
                            >
                              <button
                                className="MuiButtonBase-root MuiIconButton-root MuiIconButton-edgeEnd MuiIconButton-sizeMedium css-1ysp02-MuiButtonBase-root-MuiIconButton-root"
                                tabIndex="0"
                                type="button"
                                aria-label="Choose date"
                              >
                                <svg
                                  className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1umw9bq-MuiSvgIcon-root"
                                  focusable="false"
                                  aria-hidden="true"
                                  viewBox="0 0 24 24"
                                  data-testid="CalendarIcon"
                                >
                                  <path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"></path>
                                </svg>
                                <span className="MuiTouchRipple-root css-r3djoj-MuiTouchRipple-root"></span>
                              </button>
                            </div>
                          </div>
                        ),
                      },
                    },
                  }}
                />

                <DatePicker
                  label="End Date"
                  format="MM-DD-YYYY"
                  value={videoEndDate ? dayjs(videoEndDate) : null}
                  minDate={videoStartDate ? dayjs(videoStartDate) : dayjs()}
                  onChange={(newValue) => handleDateChange('end', newValue)}
                  slotProps={{
                    textField: {
                      variant: 'outlined',
                      placeholder: 'End date',
                      className: 'videoPickerDate',
                      InputLabelProps: {
                        shrink: true,
                      },
                      InputProps: {
                        endAdornment: videoEndDate && (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div
                              style={{ cursor: 'pointer', display: 'flex' }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDateChange('end', null);
                              }}
                            >
                              <CloseIcon fontSize="small" />
                            </div>
                            <div
                              className="MuiInputAdornment-root MuiInputAdornment-positionEnd MuiInputAdornment-outlined MuiInputAdornment-sizeMedium css-elo8k2-MuiInputAdornment-root"
                              style={{ marginLeft: '0px' }}
                            >
                              <button
                                className="MuiButtonBase-root MuiIconButton-root MuiIconButton-edgeEnd MuiIconButton-sizeMedium css-1ysp02-MuiButtonBase-root-MuiIconButton-root"
                                tabIndex="0"
                                type="button"
                                aria-label="Choose date"
                              >
                                <svg
                                  className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1umw9bq-MuiSvgIcon-root"
                                  focusable="false"
                                  aria-hidden="true"
                                  viewBox="0 0 24 24"
                                  data-testid="CalendarIcon"
                                >
                                  <path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"></path>
                                </svg>
                                <span className="MuiTouchRipple-root css-r3djoj-MuiTouchRipple-root"></span>
                              </button>
                            </div>
                          </div>
                        ),
                      },
                    },
                  }}
                />
              </DatePickerContainer>
            </Col>
          </Row>

        {daysInRange.length > 0 && (
          <Row>
            <Col span={24} style={{ marginBottom: 20 }}>
              <WeekDaysContainer>
                {weekDays.map((day) => (
                  <DayItem
                    key={day.key}
                    isInRange={daysInRange.includes(day.key)}
                    isSelected={selectedDays.includes(day.key)}
                    onClick={() => handleDayClick(day.key)}
                  >
                    {day.label}
                  </DayItem>
                ))}
              </WeekDaysContainer>
            </Col>
          </Row>
        )}
        <label style={{ fontSize: 14, fontWeight: 600, marginBottom: 10 }}>Select at least one role to display this video</label>
        <div style={{ display: 'flex', flexDirection: 'row', gap: 15, marginBottom: 10 }}>
          <div style={{ display: 'flex', alignItems: 'center'}}>
            <Checkbox
              checked={selectedTypes.teacher}
              onChange={handleChangeCheckbox('teacher')}
              color="primary"
            />
            <span>Teacher</span>
          </div>

          <div style={{ display: 'flex', alignItems: 'center'}}>
            <Checkbox
              checked={selectedTypes.student}
              onChange={handleChangeCheckbox('student')}
              color="primary"
            />
            <span>Student</span>
          </div>
        </div>
        <div className="flex">
          <Tag height={20}>
            <Star style={{ height: '12px', margin: '-1px 4px 0px 0px', width: '12px' }} />
            NOTE
          </Tag>
          <Note>
            By selecting weekdays between the Start Date and End Date, you control exactly 
            when users can see this video.
          </Note>
        </div>
       </>
      )}
        </ImageContainer>
    )
}
